module.exports = __webpack_public_path__ + "static/media/price.2c1d7c3a.svg";